import { render, staticRenderFns } from "./_Fluxo.vue?vue&type=template&id=5dad778a&scoped=true&"
import script from "./_Fluxo.vue?vue&type=script&lang=js&"
export * from "./_Fluxo.vue?vue&type=script&lang=js&"
import style0 from "./_Fluxo.vue?vue&type=style&index=0&id=5dad778a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad778a",
  null
  
)

export default component.exports